import { Card, CardContent, Grid, Typography } from "@mui/material";
import { SkeletonIndicator } from "../../../../components/skeleton-indicator.component";

interface PageAddressInfoProps {
    municipality?: any;
    isLoading?: boolean;
}

interface ComponentCell {
    isLoading: any;
    heading: string;
    value: any;
}

const styling = {
    root: { borderRadius: '10px' },
    textColor: { color: '$primary-color' },
    headingStyle: { color: '#0000b5', paddingBottom: '10px' },
    labelStyle: { color: '#0000b5', fontSize: '14px' },
    valueStyle: { color: '#000', fontWeight: '500', fontSize: '13px' },
};

const ComponentCell = ({ isLoading, heading, value }: ComponentCell) => {
    return (
        <Grid container spacing={0.5}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
                    {heading}
                </Typography>
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                {!isLoading ? (
                    <Typography variant="body1" color="text.secondary" style={styling.valueStyle}>
                        {value ? value : 'N/A'}
                    </Typography>
                ) : (
                    <SkeletonIndicator isLoading={isLoading} count={1} variant="h6" />
                )}
            </Grid>
        </Grid>
    );
};

export const PageAddressInfo = ({ municipality, isLoading }: PageAddressInfoProps) => {
    return (
        <Card elevation={0}>
            <CardContent>
                <Grid container spacing={2} className="custBoxValues">
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <ComponentCell isLoading={isLoading} heading="Coc Cover Page Address" value={municipality?.coCCoverPageAddress} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}